// EASYWEB: import per il feature flag del modello Azienda.
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
  // EASYWEB: modello Azienda, visibile solo con il feature flag companies.
  { id: 2, key: 'COMPANY', featureFlag: FEATURE_FLAGS.COMPANIES },
];

export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 6, key: 'LIST' },
  { id: 7, key: 'CHECKBOX' },
];
